import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography } from '@mui/material';

const Root = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(6),
  '& .heading-group': {
    paddingBottom: theme.spacing(2),
  },
  '& .text-center': {
    textAlign: 'center',
  },
}));

export default function ContentSection({
  children,
  heading = '',
  subheading = '',
  centerHeadings = false,
}) {
  return (
    <Root>
      {heading && (
        <div
          className={clsx('heading-group', {
            'text-center': centerHeadings,
          })}
        >
          <Typography variant="h2" sx={{ mb: subheading ? 1 : 0 }}>
            {heading}
          </Typography>
          {subheading && <Typography component="p">{subheading}</Typography>}
        </div>
      )}

      {children}
    </Root>
  );
}

// Prop Validation
ContentSection.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  centerHeadings: PropTypes.bool,
};
